import { useEffect, useState } from "react";
import { fetchDashboardChartConfig } from "@/modules/stochastic/features/Reports/SCDashboard/api/fetchDashboardChartConfig";

/**
 * The stage-curated chart list for the active company (#9292).
 * `chartKeys` is null until loaded — and stays null if the request fails,
 * which the page treats as "show everything" (fail-open, matching the
 * stage rules used elsewhere; the curation is UX, not security).
 */
export function useDashboardChartConfig(): {
  chartKeys: string[] | null;
  configLoading: boolean;
} {
  const [chartKeys, setChartKeys] = useState<string[] | null>(null);
  const [configLoading, setConfigLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    fetchDashboardChartConfig()
      .then((response) => {
        if (!cancelled) setChartKeys(response.data.chartKeys);
      })
      .finally(() => {
        if (!cancelled) setConfigLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { chartKeys, configLoading };
}
